import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projet-professionnel-evaluation-form',
  templateUrl: './projet-professionnel-evaluation-form.component.html',
  styleUrls: ['./projet-professionnel-evaluation-form.component.scss']
})
export class ProjetProfessionnelEvaluationFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
